import type { Category, PlanningCycle, SpaceTemplateBundle, TaskTemplate, Todo } from "../domain/entities.ts";
import type { TaskSyncStatus } from "../domain/app-types.ts";
import type { ShellData } from "./shell-data-controller.ts";

export class ShellDataState {
  epics: import("../domain/entities.ts").Epic[] = [];
  allAvailableTodos: Todo[] = [];
  todos: Todo[] = [];
  conflicts = new Map<string, string[]>();
  sharedTemplates: TaskTemplate[] = [];
  spaceTemplateBundles: SpaceTemplateBundle[] = [];
  cycles: PlanningCycle[] = [];
  activeCycle: string | null = null;
  categories: Category[] = [];
  categoryIndex: Category[] = [];
  categoryNames = new Map<string, string>();
  taskSyncStatuses = new Map<string, TaskSyncStatus>();

  apply(data: ShellData): void {
    this.allAvailableTodos = data.allAvailableTodos;
    this.todos = data.todos;
    this.epics = data.epics || [];
    this.conflicts = data.conflicts;
    this.sharedTemplates = data.sharedTemplates;
    this.spaceTemplateBundles = data.spaceTemplateBundles;
    this.cycles = data.cycles;
    this.activeCycle = data.activeCycle;
    this.categories = data.categories;
    this.categoryIndex = data.indexedCategories;
    this.categoryNames = new Map(data.indexedCategories.map(category => [category.id, category.name]));
    this.taskSyncStatuses = data.taskSyncStatuses;
  }

  replaceTodo(projection: Todo, activeRoot: string | null): void {
    const index = this.todos.findIndex(todo => todo.id === projection.id);
    if (index >= 0) this.todos[index] = projection;
    else if (projection.rootId === activeRoot) this.todos.push(projection);
  }

  replaceAvailableTodo(projection: Todo): void {
    const index = this.allAvailableTodos.findIndex(todo => todo.id === projection.id);
    if (index >= 0) this.allAvailableTodos[index] = projection;
    else this.allAvailableTodos.push(projection);
  }

  categoryName(id: string): string {
    return this.categoryNames.get(id) || "Unknown collection";
  }
}
